import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Button } from "@chakra-ui/react";
import { AuthWrapper } from "../components/AuthWrapper";
import http from "../connection/connect";
import "../styles/google.scss";
import { navigateToUserStoreSignedIn, safeNext, startSession } from "../helpers/global";
import { trackEvent } from "../helpers/tracking";

/**
 * "Continue with Google" for an e-mail that already has a store: swaps the
 * one-time `?code=` for a portal session, then goes to `?next=` (the portal
 * page that asked for a login, e.g. connecting Messenger) or straight into
 * the store admin, exactly like a password login.
 */
const GoogleCallback = ({ t }) => {
  const [error, setError] = useState("");

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code") || "";
    http
      .post("api/oauth/google/exchange", { code })
      .then(async ({ data }) => {
        if (data?.status !== 200 || !data.accessToken) throw new Error();
        startSession(data);
        trackEvent("login", undefined, { method: "google" });
        const next = safeNext();
        if (next) {
          window.location.replace(next);
          return;
        }
        await navigateToUserStoreSignedIn();
      })
      .catch((e) =>
        setError(
          e.response?.data?.message ||
            t("google.expired", "This sign-in has expired. Please continue with Google again.")
        )
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <AuthWrapper header={t("google.expiredTitle", "Let's try that again")}>
        <p className="sp-auth-sub">{error}</p>
        <Button width="100%" onClick={() => (window.location.href = "/login")}>
          {t("google.backToLogin", "Back to login")}
        </Button>
      </AuthWrapper>
    );
  }

  // A sign-in, not a store build: just a quiet screen until the redirect.
  return (
    <div className="sp-build" role="status" aria-live="polite">
      <div className="sp-build-inner">
        <img className="sp-build-logo" src="/logo-text-white.png" alt="StorkPlus" />
        <p className="sp-build-sub">{t("google.signingIn", "Signing you in…")}</p>
      </div>
    </div>
  );
};

export default withTranslation()(GoogleCallback);
